(function () {

  // Ajax routes need the market root, or Shopify answers in the default market. routes.root ends in '/'.
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  'use strict';
  const container = document.querySelector('[data-mini-bag]');
  if (!container) return;
  const panel = container.querySelector('[data-mini-bag-panel]');
  const overlay = container.querySelector('[data-mini-bag-overlay]');
  const trap = typeof createFocusTrap === 'function' ? createFocusTrap(panel) : null;
  let isOpen = false,
    chooseSizeOpen = false,
    changeSizeContext = null,
    lastTrigger = null,
    sizeTriggerCtrl = null,
    changeSizeInFlight = false,
    chooseSizeVariants = null,
    chooseSizeHandle = null;
  let upsellTicket = ''; // Voyado cart-page rec ticket pending for the next addUpsell (set on a rec ATB click, consumed on add)
  // Apply a state change to the panel without animating its translate transition
  // (tab-switch path): the panel jumps on/off-screen instantly while only the
  // CONTENT cross-fades via the host CSS. Mirrors wishlist-drawer.js. JS-only.
  function withNoSlide(fn) {
    var prev = panel.style.transition;
    panel.style.transition = 'none';
    fn();
    void panel.offsetWidth; // force reflow so the no-transition write commits
    requestAnimationFrame(function () {
      panel.style.transition = prev;
    });
  }
  function open(trigger, opts) {
    if (isOpen) return;
    isOpen = true;
    lastTrigger = trigger || null;
    container.removeAttribute('inert');
    container.dataset.miniBagOpen = 'true';
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    overlay.classList.add('opacity-100', 'pointer-events-auto');
    document.querySelectorAll('[data-mini-bag-trigger]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
    document.querySelector('[data-menu-toggle]')?.setAttribute('data-mini-bag-open', 'true');
    document.querySelector('[data-header]')?.setAttribute('data-mini-bag-open', 'true');
    if (!opts || !opts.tabSwitch) {
      panel.classList.remove('translate-x-full');
      panel.classList.add('translate-x-0');
      const sc = container.querySelector('[data-drawer-scroll]');
      if (sc) sc.scrollTop = 0; // open from the top
      document.documentElement.setAttribute('data-scroll-lock', '');
      if (trap) trap.activate();
      panel.focus();
    } else {
      withNoSlide(function () {
        panel.classList.remove('translate-x-full');
        panel.classList.add('translate-x-0');
      });
    }
  }

  function close(opts) {
    if (!isOpen) return;
    isOpen = false;
    container.setAttribute('inert', '');
    container.dataset.miniBagOpen = 'false';
    overlay.classList.remove('opacity-100', 'pointer-events-auto');
    overlay.classList.add('opacity-0', 'pointer-events-none');
    document.querySelectorAll('[data-mini-bag-trigger]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
    document.querySelector('[data-menu-toggle]')?.removeAttribute('data-mini-bag-open');
    document.querySelector('[data-header]')?.removeAttribute('data-mini-bag-open');
    if (!opts || !opts.tabSwitch) {
      panel.classList.remove('translate-x-0');
      panel.classList.add('translate-x-full');
      document.documentElement.removeAttribute('data-scroll-lock');
      if (trap) trap.deactivate();
      if (chooseSizeOpen) closeChooseSize();
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    } else {
      withNoSlide(function () {
        panel.classList.remove('translate-x-0');
        panel.classList.add('translate-x-full');
      });
    }
    lastTrigger = null;
  }

  // Envelope and strike cloned from the global size template, built from the same snippets as the
  // Liquid pills.
  function appendUnavailableParts(label) {
    var parts = document.querySelector('[data-tmpl-card-size]')?.content.querySelectorAll('.action-size__icon, .action-size__line');
    parts?.forEach(function (part) {
      var node = label.appendChild(part.cloneNode(true));
      node.removeAttribute('data-slot');
      node.querySelectorAll('[data-slot]').forEach(function (el) { el.removeAttribute('data-slot'); });
    });
  }

  // A pre-order variant is purchasable here only while one of its plans is offered in this market;
  // without the market module the stock flag decides alone.
  function purchasableHere(v) {
    var plans = (v && v.selling_plan_allocations) || [];
    return !!(v && v.available) && (!plans.length || !window.BroraPreorderMarket || window.BroraPreorderMarket.anyAllowed(plans));
  }

  function openChooseSize(handle, variants, changeCtx) {
    chooseSizeOpen = true;
    changeSizeContext = changeCtx || null;
    chooseSizeVariants = variants;
    chooseSizeHandle = handle;
    const pills = container.querySelector('[data-mini-bag-size-pills]');
    pills.innerHTML = '';
    variants.forEach(function (v) {
      var label = document.createElement('label');
      // whitespace-nowrap keeps a hyphenated size like "10-12" on one line inside the pill.
      label.className = 'action-size whitespace-nowrap';
      var inp = document.createElement('input');
      inp.type = 'radio';
      inp.name = 'mini-bag-upsell-size';
      inp.value = String(v.id);
      inp.setAttribute('data-mini-bag-size', '');
      var isCurrent = changeSizeContext && v.id === changeSizeContext.currentVariantId;
      if (isCurrent) {
        inp.checked = true;
        inp.disabled = true;
      } else if (!purchasableHere(v)) {
        // action-size--unavailable draws the greyed/strikethrough OOS look (mini-bag-oos-pill only
        // centres the layout); no aria-disabled here so the pill stays clickable and routes to the PDP.
        label.classList.add('mini-bag-oos-pill', 'action-size--unavailable');
        // A size change can't move to an out-of-stock size; a rec add leaves it selectable so addUpsell
        // routes the out-of-stock (and pre-order) variant to the PDP, mirroring the PDP behaviour.
        if (changeSizeContext) {
          inp.disabled = true;
          label.setAttribute('aria-disabled', 'true');
        }
      }
      var sizeOptIdx = changeSizeContext && changeSizeContext.sizeOptionIndex ? changeSizeContext.sizeOptionIndex : 1;
      var span = document.createElement('span');
      span.className = 'action-size__text';
      // A single "Default Title" variant (no real options) shows as "One Size" — mirrors the wishlist drawer.
      span.textContent = v.option1 === 'Default Title' ? 'One Size' : v['option' + sizeOptIdx];
      label.appendChild(inp);
      label.appendChild(span);
      if (!isCurrent && !purchasableHere(v)) appendUnavailableParts(label);
      pills.appendChild(label);
    });
    const cso = container.querySelector('[data-mini-bag-choose-size-overlay]');
    cso.classList.remove('opacity-0', 'pointer-events-none');
    cso.classList.add('opacity-100', 'pointer-events-auto');
    const csp = container.querySelector('[data-mini-bag-choose-size]');
    csp.classList.remove('translate-y-full');
    csp.classList.add('translate-y-0');
  }

  function closeChooseSize() {
    chooseSizeOpen = false;
    changeSizeContext = null;
    const cso = container.querySelector('[data-mini-bag-choose-size-overlay]');
    cso.classList.remove('opacity-100', 'pointer-events-auto');
    cso.classList.add('opacity-0', 'pointer-events-none');
    const csp = container.querySelector('[data-mini-bag-choose-size]');
    csp.classList.remove('translate-y-0');
    csp.classList.add('translate-y-full');
  }
  function showError(err) {
    const el = panel.querySelector('[data-mini-bag-error]');
    if (!el) return;
    el.textContent =
      err?.message === 'add_failed'
        ? (window.miniBAGStrings?.addFailed ?? 'Could not add item. Please try again.')
        : (window.miniBAGStrings?.genericError ?? 'Something went wrong. Please try again.');
    el.removeAttribute('hidden');
    setTimeout(function () {
      el.setAttribute('hidden', '');
    }, 5000);
  }

  function refreshCart(silent, scrollToTop) {
    const ctrl = new AbortController();
    const t = setTimeout(function () {
      ctrl.abort();
    }, 8000);
    fetch(shopRoot() + '?sections=mini-bag', { signal: ctrl.signal, cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('refresh_failed');
        return r.json();
      })
      .then(function (data) {
        clearTimeout(t);
        const tmp = document.createElement('div');
        tmp.innerHTML = data['mini-bag'];
        const np = tmp.querySelector('[data-mini-bag-products]');
        if (np) {
          const oldProducts = panel.querySelector('[data-mini-bag-products]');
          const scrollTop = oldProducts ? oldProducts.scrollTop : 0;
          const ymalCollapsed =
            oldProducts?.querySelector('[data-mini-bag-ymal-toggle]')?.getAttribute('aria-expanded') === 'false';
          oldProducts.replaceWith(np);
          np.scrollTop = scrollToTop ? 0 : scrollTop;
          if (ymalCollapsed) {
            np.querySelector('[data-mini-bag-ymal-toggle]')?.setAttribute('aria-expanded', 'false');
            np.querySelector('[data-mini-bag-ymal-list]')?.classList.add('hidden');
          }
        }
        const nb = tmp.querySelector('[data-mini-bag-bottom]');
        if (nb) panel.querySelector('[data-mini-bag-bottom]').replaceWith(nb);
        const nc = tmp.querySelector('[data-mini-bag-item-count]');
        if (nc) {
          const n = nc.textContent.trim();
          document.querySelectorAll('[data-mini-bag-item-count],[data-cart-count]').forEach(function (el) {
            el.textContent = n;
            if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', n);
          });
        }
        // The mini-bag DOM (incl. any Voyado recommendations shell) has just been
        // replaced with fresh server-rendered markup carrying the new cart keys.
        // Let voyado-minibag-recs.js re-query the cart-page recommendations.
        document.dispatchEvent(new CustomEvent('mini-bag:updated'));
        bindYmalWishlists(); // re-bind the curated YMAL wishlist hearts in the fresh markup
      })
      .catch(function (err) {
        clearTimeout(t);
        if (!silent) showError(err);
      });
  }
  function changeQuantity(key, delta) {
    const card = container.querySelector('[data-line-item-key="' + key + '"]');
    const qtyEl = card?.querySelector('[data-mini-bag-qty-value]');
    const newQty = Math.max(0, parseInt(qtyEl?.textContent ?? '1', 10) + delta);
    if (qtyEl) qtyEl.textContent = newQty;
    if (card) card.dataset.lineItemQty = newQty;
    card?.querySelectorAll('[data-mini-bag-qty-dec],[data-mini-bag-qty-inc]').forEach(function (b) {
      b.disabled = true;
    });
    const ctrl = new AbortController();
    const t = setTimeout(function () {
      ctrl.abort();
    }, 8000);
    fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: newQty }),
      signal: ctrl.signal,
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change_failed');
        return r.json();
      })
      .then(function () {
        clearTimeout(t);
        refreshCart();
      })
      .catch(function (err) {
        clearTimeout(t);
        showError(err);
        refreshCart();
      });
  }
  window.miniBag = { open: open, changeQuantity: changeQuantity, refreshCart: refreshCart, close: close };

  // A pre-order variant carries a Shopify selling plan (from the pre-order app) in its
  // selling_plan_allocations. preorderVariant() routes any such variant to the PDP before these add paths
  // run, so this carry is a defensive fallback — it keeps the selling plan on an add only if a plan-bearing
  // variant ever reaches upsell/size-change. Resolved from the product.js variants shown in the choose-size
  // overlay.
  function sellingPlanFor(variantId) {
    var id = Number(variantId); // call sites pass either a number (size change) or a string (upsell)
    var v = (chooseSizeVariants || []).find(function (x) {
      return x.id === id;
    });
    var a = v && (window.BroraPreorderMarket ? { selling_plan_id: window.BroraPreorderMarket.allowedPlanId(v.selling_plan_allocations) } : (v.selling_plan_allocations || [])[0]);
    return a ? a.selling_plan_id : null;
  }

  // Pre-order can ONLY be completed on the PDP: a pre-order variant must never be added from the mini-bag.
  // Client-side the only pre-order signal is a selling-plan allocation on the variant (Notify Me attaches
  // the plan to exactly the pre-order variants). Resolve it from the product.js variants already fetched
  // for the choose-size overlay.
  function preorderVariant(variantId) {
    var id = Number(variantId);
    var v = (chooseSizeVariants || []).find(function (x) {
      return x.id === id;
    });
    return v && v.selling_plan_allocations && v.selling_plan_allocations.length > 0 ? v : null;
  }
  // An out-of-stock variant can't be added from the mini-bag; it routes to the PDP like a pre-order does.
  // Resolved from the same product.js variants fetched for the choose-size overlay.
  function unavailableVariant(variantId) {
    var id = Number(variantId);
    var v = (chooseSizeVariants || []).find(function (x) {
      return x.id === id;
    });
    return v && v.available === false ? v : null;
  }

  // Route a variant to its PDP instead of touching the cart — used for adds that can't complete in the
  // mini-bag (pre-order, out of stock). If the shopper is already on THIS product's PDP (mini-bag opened
  // over it), don't navigate — close the bag and select the variant on the open PDP (leaving the existing
  // cart untouched). Otherwise navigate to the PDP on the variant.
  function routeVariantToPdp(variant) {
    // Same-PDP check by handle: product.js variants carry no product_id, so match the cart item's handle
    // (chooseSizeHandle) against the current PDP path instead of a product id.
    var pdp = document.querySelector('[data-main-product]');
    var onThisPdp =
      pdp &&
      chooseSizeHandle &&
      window.location.pathname.replace(/\/$/, '').endsWith('/products/' + chooseSizeHandle) &&
      window.broraProduct &&
      window.broraProduct.selectVariant;
    if (onThisPdp) {
      close();
      // Run after close()'s focus-trap return so selectVariant's notify-email focus (out-of-stock route)
      // takes effect.
      requestAnimationFrame(function () {
        window.broraProduct.selectVariant(variant.id, true);
      });
      return;
    }
    window.location.href = shopRoot() + 'products/' + chooseSizeHandle + '?variant=' + variant.id;
  }

  function addUpsell(variantId) {
    var preVariant = preorderVariant(variantId);
    if (preVariant) {
      closeChooseSize();
      routeVariantToPdp(preVariant);
      return;
    } // pre-order → PDP, never add here
    var oosVariant = unavailableVariant(variantId);
    if (oosVariant) {
      closeChooseSize();
      routeVariantToPdp(oosVariant);
      return;
    } // out of stock → PDP, never add here
    const recTicket = upsellTicket;
    upsellTicket = ''; // consume the pending Voyado rec ticket (set on the ATB click)
    container.querySelectorAll('[data-mini-bag-size]').forEach(function (s) {
      s.disabled = true;
    });
    const ctrl = new AbortController();
    const t = setTimeout(function () {
      ctrl.abort();
    }, 8000);
    var upsellBody = { id: variantId, quantity: 1 };
    var upsellSp = sellingPlanFor(variantId);
    if (upsellSp) upsellBody.selling_plan = upsellSp;
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(upsellBody),
      signal: ctrl.signal,
    })
      .then(function (r) {
        clearTimeout(t);
        closeChooseSize();
        if (r.ok) {
          // Adding from the recommendations (bottom of the panel) scrolls the panel back to the top so
          // the new line item is in view instead of leaving the shopper down at the recs.
          refreshCart(true, true);
          // Voyado: the minibag's add path doesn't dispatch cart:added, so trace a
          // cart-page recommendation add imperatively (no-op when there's no ticket).
          if (recTicket && window.VoyadoClient && window.VoyadoClient.notifyAddToCart)
            window.VoyadoClient.notifyAddToCart(recTicket);
        } else {
          showError(new Error('add_failed'));
        }
      })
      .catch(function (err) {
        clearTimeout(t);
        closeChooseSize();
        showError(new Error('add_failed'));
      })
      .finally(function () {
        container.querySelectorAll('[data-mini-bag-size]').forEach(function (s) {
          s.disabled = false;
        });
      });
  }
  function changeSize(variantId, key, qty) {
    var preVariant = preorderVariant(variantId);
    // New size is pre-order → do NOT perform the cart change here; route to the PDP (or close + select on it
    // if already open), where the pre-order must be completed. Record a pending swap so completing the add
    // there removes THIS original line — a real size change, not a duplicate.
    if (preVariant) {
      closeChooseSize();
      try {
        sessionStorage.setItem(
          'brora.preorderSwap',
          JSON.stringify({ removeKey: key, variantId: String(variantId), ts: Date.now() })
        );
      } catch (e) {}
      routeVariantToPdp(preVariant);
      return;
    }
    changeSizeInFlight = true;
    container.querySelectorAll('[data-mini-bag-size]').forEach(function (s) {
      s.disabled = true;
    });
    var t2 = null;
    var ctrl2 = null;
    var ctrl = new AbortController();
    var t = setTimeout(function () {
      ctrl.abort();
    }, 8000);
    fetch(
      window.routes.cart_change_url.endsWith('.js')
        ? window.routes.cart_change_url
        : window.routes.cart_change_url + '.js',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: 0 }),
        signal: ctrl.signal,
      },
    )
      .then(function (r) {
        if (!r.ok) throw new Error('change_failed');
        return r.json();
      })
      .then(function () {
        clearTimeout(t);
        ctrl2 = new AbortController();
        t2 = setTimeout(function () {
          ctrl2.abort();
        }, 8000);
        var addBody = { id: variantId, quantity: qty };
        var changeSp = sellingPlanFor(variantId);
        if (changeSp) addBody.selling_plan = changeSp;
        return fetch(
          window.routes.cart_add_url.endsWith('.js') ? window.routes.cart_add_url : window.routes.cart_add_url + '.js',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(addBody),
            signal: ctrl2.signal,
          },
        ).then(function (r) {
          clearTimeout(t2);
          if (!r.ok) throw new Error('add_failed');
          closeChooseSize();
          refreshCart();
        });
      })
      .catch(function (err) {
        clearTimeout(t);
        clearTimeout(t2);
        showError(err);
        refreshCart();
      })
      .finally(function () {
        changeSizeInFlight = false;
        container.querySelectorAll('[data-mini-bag-size]').forEach(function (s) {
          s.disabled = false;
        });
      });
  }
  function toggleYmal() {
    const btn = container.querySelector('[data-mini-bag-ymal-toggle]');
    const list = container.querySelector('[data-mini-bag-ymal-list]');
    if (!btn || !list) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    list.classList.toggle('hidden', expanded);
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-mini-bag-trigger]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
      return;
    }
    if (e.target.closest('[data-mini-bag-close]') || e.target.closest('[data-mini-bag-overlay]')) {
      close();
      return;
    }
    const dec = e.target.closest('[data-mini-bag-qty-dec]');
    if (dec) {
      const k = dec.closest('[data-line-item-key]')?.dataset.lineItemKey;
      if (k) changeQuantity(k, -1);
      return;
    }
    const inc = e.target.closest('[data-mini-bag-qty-inc]');
    if (inc) {
      const k = inc.closest('[data-line-item-key]')?.dataset.lineItemKey;
      if (k) changeQuantity(k, 1);
      return;
    }
    if (e.target.closest('[data-mini-bag-choose-size-overlay]')) {
      closeChooseSize();
      return;
    }
    var sizeTrigger = e.target.closest('[data-mini-bag-size-trigger]');
    if (sizeTrigger) {
      if (changeSizeInFlight) return;
      var card = sizeTrigger.closest('[data-line-item-key]');
      var key = sizeTrigger.dataset.lineItemKey;
      var qty = parseInt(card ? (card.dataset.lineItemQty ?? '1') : '1', 10);
      var currentVariantId = parseInt(sizeTrigger.dataset.variantId, 10);
      var sizeOptionIndex = parseInt(sizeTrigger.dataset.sizeOptionIndex, 10) || 1;
      var handle = sizeTrigger.dataset.productHandle;
      if (!handle || !key) return;
      if (sizeTriggerCtrl) {
        sizeTriggerCtrl.abort();
        changeSizeContext = null;
      }
      var ctrl = new AbortController();
      sizeTriggerCtrl = ctrl;
      var t = setTimeout(function () {
        ctrl.abort();
      }, 8000);
      fetch(shopRoot() + 'products/' + handle + '.js', { signal: ctrl.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('fetch_failed');
          return r.json();
        })
        .then(function (d) {
          clearTimeout(t);
          sizeTriggerCtrl = null;
          openChooseSize(handle, d.variants, {
            key: key,
            qty: qty,
            currentVariantId: currentVariantId,
            sizeOptionIndex: sizeOptionIndex,
          });
        })
        .catch(function (err) {
          clearTimeout(t);
          if (err.name === 'AbortError') return;
          sizeTriggerCtrl = null;
          showError(err);
        });
      return;
    }
    const atb = e.target.closest('[data-mini-bag-atb]');
    if (atb) {
      upsellTicket = atb.getAttribute('data-voyado-ticket') || ''; // Voyado cart-page rec ticket (if any) → consumed by addUpsell on a successful add
      const ctrl = new AbortController();
      const t = setTimeout(function () {
        ctrl.abort();
      }, 8000);
      fetch(shopRoot() + 'products/' + atb.dataset.productHandle + '.js', { signal: ctrl.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('fetch_failed');
          return r.json();
        })
        .then(function (d) {
          clearTimeout(t);
          // Always open the size picker (mirrors the wishlist drawer): a single-variant product shows a
          // "One Size" pill; selecting an out-of-stock / pre-order size routes to the PDP variant (addUpsell).
          openChooseSize(atb.dataset.productHandle, d.variants);
        })
        .catch(function (err) {
          clearTimeout(t);
          showError(err);
        });
      return;
    }
    if (e.target.closest('[data-mini-bag-ymal-toggle]')) {
      toggleYmal();
    }
    // [data-mini-bag-tab] → deferred
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (chooseSizeOpen) {
      closeChooseSize();
      return;
    }
    // A nested top-layer <dialog> (the gift-wrap drawer) handles its own Escape — don't also close the mini-bag.
    if (document.querySelector('[data-gift-wrap-drawer][open]')) return;
    if (isOpen) close();
  });

  container.addEventListener('change', function (e) {
    if (e.target.name !== 'mini-bag-upsell-size') return;
    if (changeSizeContext) {
      var currentCard = container.querySelector('[data-line-item-key="' + changeSizeContext.key + '"]');
      var currentQty = parseInt(
        currentCard ? (currentCard.dataset.lineItemQty ?? changeSizeContext.qty) : changeSizeContext.qty,
        10,
      );
      changeSize(parseInt(e.target.value, 10), changeSizeContext.key, currentQty);
    } else {
      addUpsell(e.target.value);
    }
  });
  document.addEventListener('cart:added', function () {
    refreshCart();
  });
  // Wrapped gift-wrap app adds/edits its gift line-items with its own AJAX (never the theme's add path,
  // so no cart:added fires) and then dispatches its configured "JavaScript callback event" — set in the
  // Wrapped admin to "wrapped:cart-updated". Re-render the drawer here so an order-level or per-item gift
  // added from inside the drawer shows immediately. Deliberately a DISTINCT name from the theme's own
  // post-refresh "mini-bag:updated" signal (dispatched by refreshCart) so there is no refresh loop; the
  // app re-injects its launchers via its own DOM observer after the swap, independent of this event.
  // The app fires it twice per save (debounced to one refresh), and may also fire it on interactions that
  // DON'T change the cart — so gate on a lightweight cart signature (count + each line key×qty; the line
  // key already encodes gift properties, so an edited message counts as a change) and only refresh when it
  // actually differs, to avoid a wasteful re-render + recs re-fetch on a no-op event. Fetch error → refresh
  // anyway (safe fallback). Lazily seeded, so at most one refresh fires before the first real comparison.
  var lastCartSig = null;
  var wrappedRefreshTimer = null;
  function cartSignature(cart) {
    return (
      (cart.item_count || 0) +
      '|' +
      (cart.items || [])
        .map(function (i) {
          return i.key + 'x' + i.quantity;
        })
        .join(',')
    );
  }
  document.addEventListener('wrapped:cart-updated', function () {
    clearTimeout(wrappedRefreshTimer);
    wrappedRefreshTimer = setTimeout(function () {
      fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var sig = cartSignature(cart);
          if (sig === lastCartSig) return; // cart unchanged (e.g. drawer open/close) → skip the refresh
          lastCartSig = sig;
          refreshCart();
        })
        .catch(function () {
          refreshCart();
        });
    }, 150);
  });
  document.addEventListener('mini-bag:open', function () {
    open();
    bindYmalWishlists();
  });
  document.addEventListener(
    'click',
    function (e) {
      if (isOpen && e.target.closest('[data-menu-toggle]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        close();
      }
    },
    { capture: true },
  );

  // Curated YMAL wishlist hearts use the shared product-card mechanism (data-wishlist).
  // They are server-rendered, so no per-card binder runs for them — bind here on load +
  // after every refreshCart / open. The Voyado rec cards are bound by voyado-minibag-recs.js
  // instead; the data-wl-bound guard prevents a double-bind when both paths run.
  function bindYmalWishlists() {
    if (!window.BroraProductCardWishlist || !window.BroraProductCardWishlist.bind) return;
    document.querySelectorAll('[data-mini-bag-ymal] [data-wishlist]:not([data-wl-bound])').forEach(function (w) {
      w.setAttribute('data-wl-bound', '');
      window.BroraProductCardWishlist.bind(w);
    });
  }
  bindYmalWishlists();

  // Opens the bag on arrival via ?open=bag, which survives both a client- and a server-side redirect
  // from /cart. Dispatches mini-bag:open — not open() — so voyado-minibag-recs.js loads the recs too.
  document.addEventListener('DOMContentLoaded', function () {
    var u;
    try { u = new URL(location.href); } catch (e) { return; }
    if (u.searchParams.get('open') !== 'bag') return;
    u.searchParams.delete('open');
    try { history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
    document.dispatchEvent(new CustomEvent('mini-bag:open'));
  });
})();
